import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _map from 'lodash/map';

import { AppContext } from 'commons-ui';

import useService from '../../../useService';

import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../formConfig';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert, app } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestCreateWebsiteUpdateInfo, getLudoVersionNumberOptions } = useService();

	const websiteOptions = _map(app.websites, (website: string) => ({ label: website, id: website }));

	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.VERSION_NUMBER].setRenderProps({ getOptions: getLudoVersionNumberOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.CONTROL_VERSION_NUMBER].setRenderProps({ getOptions: getLudoVersionNumberOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.WEBSITE_NAME].setRenderProps({ options: websiteOptions });

	const cloneWebsiteUpdateInfo = async (clonedData: any) => {
		setShowLoader(true);
		try {
			await requestCreateWebsiteUpdateInfo(clonedData);
			showAlert('Website Update Info cloned');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(true);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		cloneWebsiteUpdateInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
